<template>
  <v-footer padless class="app-footer">
    <div class="footer-checker" aria-hidden="true"></div>
    <v-container class="py-12">
      <v-row>
        <v-col cols="12" lg="3" class="pr-lg-8">
          <img :src="logo" alt="Turn 10 Racing logo" class="footer-logo" />
          <p class="text-muted body-2 mt-4 mb-5">
            Established in {{ site.established }} in {{ site.location }} from a passion for making fast cars faster
            and the drive to compete in professional endurance racing.
          </p>
          <v-btn :href="site.instagramUrl" target="_blank" rel="noopener" icon outlined small class="social-btn"
            aria-label="Turn 10 Racing on Instagram">
            <v-icon small>mdi-instagram</v-icon>
          </v-btn>
          <v-btn :href="`mailto:${site.contactEmail}`" icon outlined small class="social-btn ml-2"
            aria-label="Email Turn 10 Racing">
            <v-icon small>mdi-email-outline</v-icon>
          </v-btn>
        </v-col>

        <v-col cols="6" md="3" lg="2">
          <h4 class="footer-heading font-display">Explore</h4>
          <ul class="footer-links">
            <li v-for="link in navLinks" :key="link.to">
              <router-link :to="link.to">{{ link.title }}</router-link>
            </li>
          </ul>
        </v-col>

        <v-col cols="6" md="3" lg="2">
          <h4 class="footer-heading font-display">WRL 2026 Season</h4>
          <ul class="footer-links">
            <li v-for="track in tracks" :key="track">{{ track }}</li>
          </ul>
        </v-col>

        <v-col cols="12" sm="6" md="3" lg="3">
          <h4 class="footer-heading font-display">WRL 2027 Season</h4>
          <ul class="footer-links">
            <li v-for="round in schedule2027" :key="round.track" class="schedule-item">
              <span class="schedule-track">{{ round.track }}</span>
              <span class="schedule-dates">{{ round.dates }}</span>
            </li>
          </ul>
        </v-col>

        <v-col cols="12" sm="6" md="3" lg="2">
          <h4 class="footer-heading font-display">Contact</h4>
          <ul class="footer-links">
            <li class="d-flex align-center">
              <v-icon small class="mr-2 text-muted">mdi-map-marker-outline</v-icon>
              {{ site.location }}
            </li>
            <li class="d-flex align-center">
              <v-icon small class="mr-2 text-muted">mdi-email-outline</v-icon>
              <a :href="`mailto:${site.contactEmail}`">{{ site.contactEmail }}</a>
            </li>
            <li class="d-flex align-center">
              <v-icon small class="mr-2 text-muted">mdi-instagram</v-icon>
              <a :href="site.instagramUrl" target="_blank" rel="noopener">{{ site.instagramHandle }}</a>
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-container>

    <div class="footer-bottom">
      <v-container class="d-flex flex-column flex-sm-row align-center justify-space-between py-4">
        <span class="caption text-muted">&copy; {{ currentYear }} {{ site.name }}. All rights reserved.</span>
        <span class="caption text-muted mt-2 mt-sm-0">Palm City, Florida &middot; USA</span>
      </v-container>
    </div>
  </v-footer>
</template>

<script>
  import { SITE, NAV_LINKS, WRL_2026_TRACKS, WRL_2027_SCHEDULE } from '@/utils/siteConfig';

  export default {
    name: 'footer-comp',
    data() {
      return {
        logo: require('@/assets/logo/turn10-logo-sm.png'),
        site: SITE,
        navLinks: NAV_LINKS,
        tracks: WRL_2026_TRACKS,
        schedule2027: WRL_2027_SCHEDULE,
        currentYear: new Date().getFullYear(),
      };
    },
  };
</script>

<style scoped>
  .app-footer.v-footer {
    display: block;
    background: #07080B !important;
    border-top: 1px solid var(--t10-border);
  }

  /* Checkered flag strip echoing the logo */
  .footer-checker {
    height: 8px;
    background-image:
      linear-gradient(45deg, #fff 25%, transparent 25%, transparent 75%, #fff 75%),
      linear-gradient(45deg, #fff 25%, transparent 25%, transparent 75%, #fff 75%);
    background-size: 8px 8px;
    background-position: 0 0, 4px 4px;
    background-color: #000;
    opacity: 0.14;
  }

  .footer-logo {
    height: 64px;
    width: auto;
    display: block;
  }

  .footer-heading {
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 16px;
  }

  .footer-links {
    list-style: none;
    padding: 0 !important;
    margin: 0;
  }

  .footer-links li {
    color: var(--t10-text-muted);
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 10px;
    word-break: break-word;
  }

  .schedule-item {
    display: flex;
    flex-direction: column;
  }

  .schedule-track {
    line-height: 1.35;
  }

  .schedule-dates {
    color: var(--t10-blue-light);
    font-size: 12px;
    letter-spacing: 0.02em;
  }

  .footer-links a {
    color: var(--t10-text-muted);
    text-decoration: none;
    transition: color 0.15s ease;
  }

  .footer-links a:hover {
    color: #fff;
  }

  .social-btn.v-btn--outlined {
    border-color: var(--t10-border);
    color: var(--t10-text-muted) !important;
  }

  .social-btn.v-btn--outlined:hover {
    border-color: var(--t10-blue);
    color: #fff !important;
  }

  .footer-bottom {
    border-top: 1px solid var(--t10-border);
  }
</style>
